import { render } from "./ServicosTabPage.vue?vue&type=template&id=2eb7919b"
import script from "./ServicosTabPage.vue?vue&type=script&lang=js"
export * from "./ServicosTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__